import { useQuery } from "@tanstack/react-query";

import type { PDFBookmark } from "./helper-types";

import {
  neverRefetchOptions,
  QUERY_BOOKMARKS_SCOPE,
} from "./loaders/constants";
import { usePDFStore } from "./providers";

interface UsePDFBookmarkChildrenOptions {
  enabled?: boolean;
}
export function usePDFBookmarkChildren(
  pdfBookmark: PDFBookmark,
  options?: UsePDFBookmarkChildrenOptions,
) {
  const { data: pdfViewerCtrl } = usePDFStore((state) => ({
    id: state.id,
    pdfViewer: state.pdfViewer,
  }));

  const { data: bookmarks } = useQuery({
    queryKey: [
      ...QUERY_BOOKMARKS_SCOPE,
      pdfViewerCtrl?.id,
      pdfBookmark.id,
      "children",
    ],
    queryFn: () =>
      pdfViewerCtrl?.pdfViewer
        ?.getBookmarkDataService()
        .getBookmarkChildren(pdfBookmark.id) as Promise<PDFBookmark[]>,
    enabled: Boolean(
      pdfViewerCtrl?.pdfViewer &&
      pdfViewerCtrl.id &&
      pdfBookmark.hasChild &&
      options?.enabled,
    ),
    ...neverRefetchOptions,
  });

  return bookmarks;
}
